<template>
  <div>
    <b-form-group label="Nome:">
      <b-form-input
        v-model="physical_person.name"
        placeholder="Nome"
        :state="validateState('name')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="CPF:">
      <b-form-input
        v-model="cpf"
        placeholder="CPF"
        :formatter="formatterCpf"
        :state="validateState('cpf')"
      ></b-form-input>
      <b-form-invalid-feedback>
        <span v-if="!$v.physical_person.cpf.required"
          >CPF é um campo obrigatório.</span
        >
        <span v-if="!$v.physical_person.cpf.cpf">CPF inválido</span>
        <span v-if="!$v.physical_person.cpf.is_unique"
          >CPF já está em uso por outra pessoa</span
        >
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="RG:">
      <b-form-input
        v-model="physical_person.rg"
        placeholder="RG"
        :state="validateState('rg')"
      ></b-form-input>
      <b-form-invalid-feedback
        >RG é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { cpf } from "cpf-cnpj-validator";
import { mapState } from "vuex";
import { mask } from "vue-the-mask";

export default {
  props: {
    cpf_invalid: {
      default: null
    },
    rg_invalid: {
      default: null
    }
  },
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    physical_person: {
      name: {
        required,
        minLength: minLength(3)
      },
      cpf: {
        cpf: value => {
          return !value || cpf.isValid(value);
        },
        is_unique(value) {
          return value != this.cpf_invalid;
        }
      },
      rg: {}
    }
  },
  computed: {
    ...mapState("physical_people", ["physical_person"]),
    cpf: {
      set(value) {
        value = value.replace(/\D/g, "").substring(0, 11);
        this.physical_person.cpf = value;
      },
      get() {
        let value = this.physical_person.cpf.replace(
          /^(\d{3})(\d{3})(\d{3})(\d)/,
          "$1.$2.$3-$4"
        );
        return value;
      }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.physical_person[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.physical_person.$touch();
      return !this.$v.physical_person.$anyError;
    },
    formatterCpf(value) {
      value = value.replace(/\D/g, "").substring(0, 11);
      value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      return value;
    }
  },
  created() {},
  directives: { mask }
};
</script>
